<template>
    <div>
        <router-view v-if="$route.params.id"></router-view>
        <List v-else></List>
    </div>
</template>

<script>
    import List from '@/views/coupon_type/List.vue'
    export default {
        components: {
            List
        }
    }
</script>
